/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React, { useState } from "react";
import { BackgroundPanel, TextArea, SwitchButtons } from "vr-react-components";
import { useSelector } from "react-redux";

function JobLogPanel({
    jobLog,
    width,
    height,
    linesPerPage,
    textSizeDecimal,
    ...otherAttributes
}) {
    const canModify = useSelector((state) => state.private.device.canModify);

    const [selectedButton, setSelectedButton] = useState("Current");

    if (jobLog && !jobLog.previous)
        jobLog.previous = "There are no successful instance of this job";

    return (
        <BackgroundPanel
            width={width}
            height={height}
            opacity={1}
            title="Job log details"
            textSizeDecimal={15}
            textOffset={{ x: width / 20, y: width / -10 }}
            {...otherAttributes}
        >
            <SwitchButtons
                height={height * 0.1}
                width={width * 0.9}
                aframeClasses={canModify ? "collidable" : ""}
                options={[
                    {
                        element: "Current",
                        onClickHandler: () => {
                            setSelectedButton("Current");
                        },
                    },
                    {
                        element: "Previous successful",
                        onClickHandler: () => {
                            setSelectedButton("Previous successful");
                        },
                    },
                ]}
                textSizeDecimal={50 / width}
                selected={selectedButton}
                position={`0 ${height * 0.3 + height * 0.035 + 0.03} ${width / 100}`}
            />
            <TextArea
                text={
                    jobLog
                        ? selectedButton === "Current"
                            ? jobLog.current
                            : jobLog.previous
                        : "Job Log not available"
                }
                aframeClasses={canModify ? "collidable" : ""}
                width={width * 0.9}
                height={height * 0.7}
                position={`0 ${-height * 0.1} ${width / 100} 0.001`}
                linesPerPage={linesPerPage}
                textSizeDecimal={textSizeDecimal}
                font="sourcecodepro"
            />
        </BackgroundPanel>
    );
}

export default JobLogPanel;
